// extracted by mini-css-extract-plugin
export default {"root":"Autocomplete-module__root___vhPI3","focused":"Autocomplete-module__focused___oWFUl","iconButton":"Autocomplete-module__iconButton___8pI3p"};